/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
} from "@mui/material";
import {
  checkCreatePermissionBasedOnMouvementType,
  checkUpdatePermissionBasedOnMouvementType,
  formatQuantity,
  printSale,
} from "../../services/utils";
import { useSelector, useDispatch } from "react-redux";
import ArticleAutocomplete from "../AutoComplete/ArticleAutoComplete";
import {
  createSale,
  updateSale,
  clearSelectedSale,
  clearAlerts,
  generateDocumentNumber,
} from "../../store/salesSlice";
import { setSelectedArticle } from "../../store/articleSlice";
// import { useSnackbar } from "../MySnackbar";
import DynamicQuantityInput from "../PackAndBottleInputMUI";
import {
  setInputValue,
  setQuantity,
  selectQuantity,
  resetQuantityState,
} from "../../store/dynamicQteInmputSlice"; // Adjust path if need
import StatusDropdown from "../StatusDropdown";
import ClientFournisseurAutoComplete from "../AutoComplete/ClientFournisseurAutoComplete";
import { selectFieldState } from "../../store/formValidationSlice";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { showSnackbar } from "../../store/snackbarSlice";
import MyButton from "../MyButton";
import ShopSelect from "../ShopSelect";

const SaleForm = ({ onClose }) => {
  // const showSnackbar = useSnackbar();
  const dispatch = useDispatch();
  const { selectedShop } = useSelector((state) => state.shop);
  const { selectedMouvement } = useSelector((state) => state.mouvementTypes);
  const { selectedArticle } = useSelector((state) => state.article);
  const { selectedSale, message, error,generatedNumero } = useSelector((state) => state.sale);
  const { quantity, quantityError } = useSelector(selectQuantity);

  const [destinationShop, setdestinationShop] = useState(null);

  const handleDestinationShop = (shop) => {
    setdestinationShop(shop);
    setGeneralProps((prevState => ({
      ...prevState, 
      shopDestination: shop._id,
    })));
    console.log("generalprops:", generalProps);
  };

  const handleGenerateDocNumber = async () => {
    const typeId = selectedMouvement._id; // e.g., selected from a dropdown
    dispatch(generateDocumentNumber(typeId));
  };

  // Get quantity from Redux
  const { selectedClientFournisseur } = useSelector(
    (state) => state.clientFournisseur
  );
  const [reset, setReset] = useState(false);

  const [generalProps, setGeneralProps] = useState({
    id: -1,
    numero: selectedMouvement
    ? selectedMouvement.numero
    : "",
    shop: selectedShop?._id,
    mouvementType: selectedMouvement
      ? selectedMouvement._id
      : selectedSale.mouvementType,
    clientFournisseur: selectedClientFournisseur
      ? selectedClientFournisseur._id
      : "",
    shopDestination:destinationShop?._id,
    extraNote: "",
    status: "",
    date: new Date().toISOString().split("T")[0],
    articles: [],
  });

  // State for the articles array
  const [newArticle, setNewArticle] = useState({
    article: { _id: "", name: "", code: "" ,calculatedDelivery:0},
    quantity: "",
    price: "",
    totalPrice: "",
  });

  // States to manage errors
  const [errors, setErrors] = useState({
    generalProps: {},
    newArticle: {},
  });

  const clientFieldState = useSelector((state) =>
    selectFieldState(state, "clientFournisseur")
  );

  useEffect(() => {
    if (message || error) {
      const type = message ? "success" : "error";
      const content = message || error;

      // Show snackbar with appropriate type
      dispatch(showSnackbar({ message: content, severity: type }));
      dispatch(clearAlerts());
      // Clear the form and fetch articles if successful
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, error]);

  useEffect(() => {
    dispatch(handleGenerateDocNumber)
    return () => {
      dispatch(clearSelectedSale());
      dispatch(clearAlerts());
    };
  }, []);

  useEffect(() => {
    if (generatedNumero) {
      setGeneralProps((prev) => ({
        ...prev,
        numero: generatedNumero,
      }));
    }
  }, [generatedNumero]);

  const [isDirty, setIsDirty] = useState(false);
  useEffect(() => {
    if (onClose) {
      onClose(isDirty);
    }
  }, [isDirty, onClose]);

  useEffect(() => {
    if (selectedArticle) {
      setNewArticle({
        ...newArticle,
        article: {
          _id: selectedArticle._id,
          name: selectedArticle.name,
          code: selectedArticle.code,
        },
        price: selectedArticle.price_v
          ? selectedArticle.price_v
          : newArticle.price,
      });
    }
  }, [selectedArticle]);

  useEffect(() => {
    if (selectedClientFournisseur) {
      setGeneralProps((prevState) => {
        const saleWithCF = {
          ...prevState,
          clientFournisseur: selectedClientFournisseur._id,
        };
        return saleWithCF;
      });
    }
  }, [selectedClientFournisseur]);

  useEffect(() => {
    if (selectedSale) {
      setGeneralProps((prevState) => {
        const saleWithMappedId = {
          ...selectedSale,
          id: selectedSale._id,
          articles: selectedSale.articles, // Utilise l'ancien état si articles locaux
        };
        return saleWithMappedId;
      });
    }
  }, [selectedSale]);

  // Validation logic
  const validateGeneralProps = () => {
    let tempErrors = {};
    if (!generalProps.numero) tempErrors.numero = "Numero is required";
    if (!generalProps.mouvementType)
      tempErrors.mouvementType = "Mouvement Type is required";
    if (!generalProps.date) tempErrors.date = "Date is required";
    if (clientFieldState.error)
      tempErrors.clientFournisseur = "Tiers is required";
    setErrors((prevState) => ({
      ...prevState,
      generalProps: tempErrors,
    }));
    return Object.keys(tempErrors).length === 0;
  };

  const handleReset = () => {
    // Trigger the reset by toggling the state
    setReset(true);
    // Optionally set it back to false after the component processes the reset
    setTimeout(() => setReset(false), 0);
  };
  const clearArticle = () => {
    handleReset();
    setNewArticle({
      article: { _id: "", name: "", code: "",calculatedDelivery:0 },
      quantity: "",
      price: "",
      totalPrice: "",
      
    });
    dispatch(resetQuantityState()); // Reset the quantity state in Redux
  };
  const validateArticle = () => {
    let tempErrors = {};
    if (!newArticle.article) tempErrors.article = "Article is required";
    if (newArticle.article.code === "")
      tempErrors.article = "Article is required";
    if (newArticle.article.name === "")
      tempErrors.article = "Article is required";
    if (!quantity || quantity <= 0)
      tempErrors.quantity = "Valid quantity is required";
    // if (!newArticle.price || newArticle.price <= 0)
    //   tempErrors.price = "Valid price is required";
    if (quantityError) tempErrors.quantity = quantityError;
    setErrors((prevState) => ({
      ...prevState,
      newArticle: tempErrors,
    }));
    return Object.keys(tempErrors).length === 0;
  };

  const handleGeneralPropsChange = (e) => {
    const { name, value } = e.target;
    setGeneralProps((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setIsDirty(true);
  };

  const [editIndex, setEditIndex] = useState(null);

  const handleAddArticle = () => {
    if (validateArticle()) {
      // Calculer le totalPrice avant d'ajouter ou de mettre à jour

      const updatedArticle = {
        ...newArticle,
        article: selectedArticle,
        quantity: quantity, // Use Redux-managed quantity
        price: parseFloat(newArticle.price || 0),
        totalPrice:
          parseFloat(newArticle.price || 0) * parseFloat(quantity || 0), // Use `quantity` state
      };

      setGeneralProps((prevState) => {
        const updatedArticles = [...prevState.articles];
        if (editIndex !== null) {
          updatedArticles[editIndex] = updatedArticle; // Mettre à jour l'article existant
        } else {
          updatedArticles.push(updatedArticle); // Ajouter un nouvel article
        }
        return {
          ...prevState,
          articles: updatedArticles,
        };
      });

      setIsDirty(true);
      clearArticle();
      setEditIndex(null); // Réinitialiser l'état d'édition
    }
  };

  const handleCreate = (e) => {
    e.preventDefault();
    if (validateGeneralProps()) {
      setIsDirty(false);
      if (selectedSale) {
        dispatch(updateSale(generalProps));
      } else {
        dispatch(createSale(generalProps));
      }
      // console.log(generalProps)
    }
  };

  const handleEditArticle = async (index) => {
    const articleToEdit = generalProps.articles[index];
    // Set the edit index
    setEditIndex(index); // Save the index being edited

    // Prepopulate with the selected article's details
    await dispatch(setSelectedArticle(articleToEdit.article));

    // Set both Redux and local state for quantity
    dispatch(setQuantity(articleToEdit.quantity)); // Update quantity in Redux
    dispatch(setInputValue(articleToEdit.quantity)); // Update quantity in Redux
    setNewArticle({
      ...articleToEdit, // Set article details
      quantity: articleToEdit.quantity, // Ensure quantity is updated from the article
    });
  };

  const handleDeleteArticle = (index) => {
    setGeneralProps((prevState) => ({
      ...prevState,
      articles: prevState.articles.filter((_, i) => i !== index),
    }));
    setIsDirty(true); // Mark the form as dirty since we've made changes
  };

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     handleAddArticle(); // Call your add article function
  //   }
  // };

  return (
    <Box padding={2}>
      <form onSubmit={handleCreate}>
        {/* General Properties Form */}
        <Paper elevation={3} style={{ marginBottom: 16, padding: 16 }}>
          <Typography variant="h6">General Properties</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Numero"
                name="numero"
                value={generalProps.numero}
                onChange={handleGeneralPropsChange}
                error={!!errors.generalProps.numero}
                helperText={errors.generalProps.numero}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Extra Notes"
                name="extraNote"
                value={generalProps.extraNote}
                onChange={handleGeneralPropsChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <StatusDropdown
                generalProps={generalProps}
                handleGeneralPropsChange={handleGeneralPropsChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Date"
                name="date"
                type="date"
                //InputLabelProps={{ shrink: true }}
                value={
                  generalProps.date
                    ? new Date(generalProps.date).toISOString().split("T")[0]
                    : ""
                }
                onChange={handleGeneralPropsChange}
                error={!!errors.generalProps.date}
                helperText={errors.generalProps.date}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ClientFournisseurAutoComplete
                required={true}
                reset={false}
                fieldName="clientFournisseur"
                error={errors.generalProps.clientFournisseur}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ShopSelect onSelect={handleDestinationShop}
               mouvementType={selectedMouvement._id}
               defaultShopId={selectedSale?.shopDestination}/>
            </Grid>
          </Grid>
        </Paper>

        {/* Articles Form */}
        <Paper elevation={3} style={{ padding: 16 }}>
          <Typography variant="h6">Add Articles</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <ArticleAutocomplete
                required={true}
                reset={reset}
                searchBy="code"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <ArticleAutocomplete
                required={true}
                reset={reset}
                searchBy="name"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DynamicQuantityInput />
            </Grid>
            {/* <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Price"
                name="price"
                type="number"
                value={newArticle.price}
                onChange={(e) =>
                  setNewArticle({ ...newArticle, price: e.target.value })
                }
                error={!!errors.newArticle.price}
                helperText={errors.newArticle.price}
                required
              />
            </Grid> */}
          </Grid>
          <Grid item xs={12} style={{ marginTop: 16 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleAddArticle}
              fullWidth
            >
              {editIndex !== null ? "Update Article" : "Add Article"}
            </Button>
          </Grid>
        </Paper>

        {/* Display Articles Table */}
        {generalProps.articles.length > 0 && (
          <Paper elevation={3} style={{ marginTop: 16, padding: 16 }}>
            <Typography variant="h6">Added Articles</Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Code</TableCell>
                    <TableCell>Article</TableCell>
                    <TableCell>Quantity</TableCell>
                    {/* <TableCell>Price</TableCell>
                <TableCell>Total</TableCell> */}
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {generalProps.articles.map((article, index) => (
                    <TableRow key={index}>
                      <TableCell>{article?.article?.code}</TableCell>
                      <TableCell>{article?.article?.name}</TableCell>
                      <TableCell>
                        {formatQuantity({
                          isVenteDetail: article?.article?.isAlowSecondaryUnit, // Passing correct parameter
                          quantity: article?.quantity,
                          nombreDePiece: article?.article?.unitsQte,
                          primaryUnit: article?.article?.primaryUnits,
                          secondaryUnit: article?.article?.secondaryUnits, // Include secondary unit if needed
                        })}
                      </TableCell>
                      {/* <TableCell>{article?.price}</TableCell>
                  <TableCell>{article?.totalPrice}</TableCell> */}
                      <TableCell>
                        {/* Edit Button */}
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => handleEditArticle(index)}
                        >
                          Edit
                        </Button>
                        {/* Delete Button */}
                        <Button
                          variant="outlined"
                          color="error"
                          style={{ marginLeft: "8px" }}
                          onClick={() => handleDeleteArticle(index)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={2} align="right">
                      <strong>Totals:</strong>
                    </TableCell>
                    <TableCell>
                      {/* Total Quantity */}
                      {generalProps.articles.reduce(
                        (sum, article) => sum + article.quantity,
                        0
                      )}
                    </TableCell>
                    <TableCell />
                    {/* <TableCell>
            {generalProps.articles.reduce((sum, article) => sum + (article.totalPrice || 0), 0)}
          </TableCell> */}
                    <TableCell />
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} align="right">
                      <strong>Unique Articles:</strong>
                    </TableCell>
                    <TableCell>
                      {/* Unique Article Count */}
                      {
                        new Set(
                          generalProps.articles.map(
                            (article) => article?.article?.code
                          )
                        ).size
                      }
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        )}

        {/* Submit Button */}
        <Paper elevation={3} style={{ marginTop: 16, padding: 16 }}>
          <Grid container justifyContent="center">
            {/* <Button variant="contained" color="primary" onClick={handleCreate}>
              {selectedSale ? "Update Sale" : "Submit Sale"}
            </Button> */}
            <MyButton
              type={selectedSale ? "update": "create"}
              action={selectedSale ? 
                      checkUpdatePermissionBasedOnMouvementType(selectedSale?.mouvementType):
                      checkCreatePermissionBasedOnMouvementType(selectedMouvement?._id)
                    }
              onClick={handleCreate}
            > 
              {selectedSale ? "Update Sale" : "Submit Sale"}
            </MyButton>
          </Grid>
        </Paper>
      </form>
      <Button onClick={()=>{printSale(selectedSale,selectedMouvement.name)}}>
        Print
        <LocalPrintshopIcon />
      </Button>
    </Box>
  );
};

export default SaleForm;
